<template>
  <div>
    <div v-if="errorMessage" class="alert alert-error mt-5">
      {{ errorMessage }}
    </div>
    <div v-else-if="message" class="alert alert-info  mt-5">
      {{ message }}
    </div>
    <div v-if="showPrompt">
      <div v-if="userParamPresent">
        <div class="form-group" data-toggle="tooltip" :data-title="tooltip">
          <label for="password" class="form-label">New Password</label>
          <input type="password" class="form-control" id="password" v-model="entity.password" placeholder="Password"/>
        </div>
        <div class="form-group">
          <label for="password" class="form-label">New Password Confirmation</label>
          <input type="password" class="form-control" id="passwordConfirmation" v-model="entity.passwordConfirmation" placeholder="Password"/>
        </div>
      </div>
      <div v-else>
        <div class="form-group">
          <label for="username" class="form-label">Username</label>
          <input type="text" class="form-control" id="username" v-model="entity.username" placeholder="Username"/>
        </div>
      </div>
    </div>
    <button class="btn btn-primary" type="button" @click="back">Back</button>
    <button v-if="showPrompt" class="btn btn-primary" type="button" @click="resetPassword" :disabled="!valid">Reset Password</button>
  </div>
</template>

<script>
  import API from '../api/endpoints.js'

  export default {
    name: 'PasswordReset',
    data (router) {
      return {
        entity: {
          username: '',
          password: '',
          passwordConfirmation: ''
        },
        message: null,
        errorMessage: null,
        showPrompt: true,
        tooltip: 'Password must at least 8 characters, and contains lowercase character(s), uppercase character(s), special character(s) and number(s)'
      }
    },
    computed: {
      userParamPresent () {
        return this.$route.query.u
      },
      valid () {
        if (this.userParamPresent) {
          return this.entity.username &&
            this.entity.password &&
            this.entity.passwordConfirmation &&
            this.passwordsMatch(this.entity.password, this.entity.passwordConfirmation) &&
            this.checkPasswordStrength(this.entity.password)
        }
        return this.entity.username && this.entity.username.length > 4
      }
    },
    methods: {
      resetPassword () {
        this.message = ''
        this.errorMessage = ''
        this.showPrompt = false
        const url = API.PWD_RESET
        const method = this.userParamPresent ? 'put' : 'post'
        this.$http[method](API.PWD_RESET, this.entity).then(res => {
          if (this.userParamPresent) {
            this.$router.push({ name: 'Login' })
          } else {
            this.message = 'Password reset link has been sent to your email. Please reset password within the next 60 minutes.'
            this.showPrompt = false
          }
        }).catch(({body}) => {
          this.errorMessage = body
        })
      },
      back (e) {
        this.$router.push({ name: 'Login' })
      },
      passwordsMatch (str1, str2) {
        return str1 === str2
      },
      checkPasswordStrength (str) {
        const pass = str && str.trim()
        return pass && !!pass.match(/((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$\\*%!&]).{8,30})/)
      }
    },
    mounted () {
      if (this.userParamPresent) {
        this.entity.username = this.$route.query.u
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PasswordReset.vue